// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Posts_wrapper__35Pi-","paper":"Posts_paper__lXKA2","spy":"Posts_spy__1D_US","posts":"Posts_posts__Yumy9"};